import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import { DateTimeAdapter, OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-date',
   templateUrl: './date.component.html',
   styleUrls: ['./date.component.css'],
   providers: [DatePipe]
})
export class DateComponent implements OnInit, AfterViewInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: string;
   @Input() placeholder: any;
   @Input() labelName: any;
   @Input() isFormName: any;
   @Input() classes: any;
   @Input() isDisabled: boolean;
   @Input() haveSign: boolean;
   @Input() hideHeader: boolean = false;
   date: any;
   time: any;
   dateTime: any;
   yearBC: number;
   regexDate: string;
   regexTime: string;
   errorMsg: string;
   defaultDate: string;
   defaultTime: string;
   defaultMsg: string;
   validateDate = false;
   dateFormat: any = [
      {
         regD: '(([0-2][0-9]|(3)[0-1]))',
         regM: '(January|February|March|April|May|June|July|August|September|October|November|December)',
         regY: '\\d{4}',
         format: 'dd,MMMM,yyyy',
         defaultDate: '01,January,2020'
      },
      {
         regD: '(([0-2][0-9]|(3)[0-1]))',
         regM: '(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)',
         regY: '\\d{4}',
         format: 'dd,MMM,yyyy',
         defaultDate: '01,Jan,2020'
      },
      {
         regD: '([0-2][0-9]|(3)[0-1])',
         regM: '(((0)[0-9])|((1)[0-2]))',
         regY: '\\d{4}',
         format: 'dd,MM,yyyy',
         defaultDate: '01,01,2020'
      },
      {
         regD: '([0-2][0-9]|(3)[0-1])',
         regM: '(((0)[0-9])|((1)[0-2]))',
         regY: '\\d{2}',
         format: 'dd,MM,yy',
         defaultDate: '01,01,20'
      },
   ];
   separateDate: any = ['-', '/', 's', ','];
   value: any;

   constructor(public datePipe: DatePipe, private translate: TranslateService,private dateTimeAdapter: DateTimeAdapter<any>, private owlDateTime: OwlDateTimeIntl, private eformService: EformService
      ,private cdr: ChangeDetectorRef
   ) {
      this.translate.get('eform.button.cancel-btn-label').subscribe(s => {
         this.owlDateTime.cancelBtnLabel = s;
      });
      this.translate.get('eform.button.set-btn-label').subscribe(s => {
         this.owlDateTime.setBtnLabel = s;
      });

   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      this.translate.get('preview.error-msg-default-date').subscribe(s => {
         this.defaultMsg = s;
      });
      if (this.field.type === 'date') {
         this.onDate('');
         this.regexDate = '^' + this.regexDate + '\\s*$';
         this.setValidators(this.regexDate, this.field.type, this.defaultDate);
      } else if (this.field.type === 'time') {
         this.onChangeTime('');
         this.regexTime = '^' + this.regexTime + '\\s*$';
         this.setValidators(this.regexTime, this.field.type, this.defaultTime);
      } else {
         this.onChangeDateTime('');
         this.regexDate = '^(' + this.regexDate + ')\\s(' + this.regexTime + ')\\s*$';
         this.setValidators(this.regexDate, this.field.type, this.defaultDate);
      }
   }

   setValidators(regex, type, defaultDateTime) {
      this.field.required ? this.form.controls[this.fieldName].setValidators([Validators.required, Validators.pattern(regex)]) :
         this.form.controls[this.fieldName].setValidators(Validators.pattern(regex));
      this.translate.get('preview.error-msg-' + type).subscribe(s => {
         this.errorMsg = s + ' ' + defaultDateTime;
      });

   }

   transformDate(date, dateFormat, separateDate, year): void {
      this.regexDate = `${dateFormat.regD}(\\${separateDate})${dateFormat.regM}(\\${separateDate})${dateFormat.regY}`;
      separateDate = (separateDate === 's') ? ' ' : separateDate;
      if (date !== '') {
         this.date = this.datePipe.transform(this.date, dateFormat.format.replace(/,/g, separateDate));
         if (year === 3) {
            (this.field.dateOption === 1) ? this.convertYear(separateDate, 1) : this.convertYear(null, 0);
         } else {
            (this.field.dateOption === 1) ? this.convertYear(separateDate, 0) : this.convertYear(null, 0);
         }
      }
      this.defaultDate = dateFormat.defaultDate.replace(/,/g, separateDate);
   }

   onDate(event): void {
      var value = event.value;
      this.date = (event !== '') ? value : '';
      this.transformDate(this.date, this.dateFormat[this.field.dateFormat], this.separateDate[this.field.separateDate], this.field.dateFormat);
      this.form.controls[this.fieldName].setValue(this.date);

   }

   onChangeTime(event) {
      if (this.field.timeFormat !== null || this.field.timeOption !== null) {
         switch (this.field.timeOption) {
            case 1 : {
               switch (this.field.timeFormat) {
                  case 1 : {
                     this.regexTime = '(([0-1][0-9]):([0-5][0-9]):([0-5][0-9])\\s(AM|PM|am|pm|aM|Am|pM|Pm{2,2}))';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'hh:mm:ss aaa') : '';
                     this.defaultTime = '08:15:00 AM';
                     break;
                  }
                  case 2 : {
                     this.regexTime = '(([0-1][0-9]):([0-5][0-9]):([0-5][0-9]):([0-9][0-9][0-9])\\s(AM|PM|am|pm|aM|Am|pM|Pm{2,2}))';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'hh:mm:ss:SSS aaa') : '';
                     this.defaultTime = '08:15:00:000 AM';
                     break;
                  }
                  default : {
                     this.regexTime = '(([0-1][0-9]):([0-5][0-9])\\s(AM|PM|am|pm|aM|Am|pM|Pm{2,2}))';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'hh:mm aaa') : '';
                     this.defaultTime = '08:15 AM';
                     break;
                  }
               }
               break;
            }
            default : {
               switch (this.field.timeFormat) {
                  case 1 : {
                     this.regexTime = '([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9])';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'HH:mm:ss') : '';
                     this.defaultTime = '08:15:00';
                     break;
                  }
                  case 2 : {
                     this.regexTime = '([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9]):([0-9][0-9][0-9])';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'HH:mm:ss:SSS') : '';
                     this.defaultTime = '08:15:00:000';
                     break;
                  }
                  default : {
                     this.regexTime = '([0-1][0-9]|[2][0-3]):([0-5][0-9])';
                     this.time = (event !== '') ? this.datePipe.transform(event, 'HH:mm') : '';
                     this.defaultTime = '08:15';
                     break;
                  }
               }
               break;
            }
         }
      } else {
         this.regexTime = '([0-1][0-9]|[2][0-3]):([0-5][0-9])';
         this.time = (event !== '') ? this.datePipe.transform(event, 'HH:mm') : '';
         this.defaultTime = '08:15';
      }
      this.form.controls[this.fieldName].setValue(this.time);
   }

   onChangeDateTime(event) {
      this.onDate(event);
      if (event !== '') {
         this.onChangeTime(event.value);
         this.dateTime = this.date + ' ' + this.time;
         this.form.controls[this.fieldName].setValue(this.dateTime);
         this.defaultDate = this.defaultDate + ' ' + this.defaultTime;
      } else {
         this.onChangeTime('');
         this.defaultDate = this.defaultDate + ' ' + this.defaultTime;
      }
   }

   convertYear(params, index, year?) {
      if (params !== null) {
         const splitted = this.date.split(params, 3);
         this.yearBC = (index === 0) ? (Number(splitted[2])) + 543 : (Number(splitted[2])) + 43;
         this.date = splitted[0] + params + splitted[1] + params + this.yearBC;
      } else if (year !== '') {
         if (this.field.dateOption === 1) {
            if (year.toString().charAt(2)) {
               return (Number(year)) - 543;
            } else {
               return ((Number(year)) - 43) + 2000;
            }
         } else {
            if (Number(year) <= 100) {
               return (Number(year)) + 2000;
            }
         }
      }
   }

   convertMonth(value) {
      let month = '';
      if (value === 'Jan' || value === 'January') {
         month = '01';
      } else if (value === 'Feb' || value === 'February') {
         month = '02';
      } else if (value === 'Mar' || value === 'March') {
         month = '03';
      } else if (value === 'Apr' || value === 'April') {
         month = '04';
      } else if (value === 'May' || value === 'May') {
         month = '05';
      } else if (value === 'Jun' || value === 'June') {
         month = '06';
      } else if (value === 'Jul' || value === 'July') {
         month = '07';
      } else if (value === 'Aug' || value === 'August') {
         month = '08';
      } else if (value === 'Sep' || value === 'September') {
         month = '09';
      } else if (value === 'Oct' || value === 'October') {
         month = '10';
      } else if (value === 'Nov' || value === 'November') {
         month = '11';
      } else if (value === 'Dec' || value === 'December') {
         month = '12';
      } else {
         month = value;
      }
      return month;
   }

   validateFormatDate(value) {
      this.validateDate = false;
      let resValue = '';
      if (value !== '') {
         value = value.target.value;
         switch (this.field.separateDate) {
            case 0 : {
               resValue = value.toString().split('-', 3);
               break;
            }
            case 1 : {
               resValue = value.toString().split('/', 3);
               break;
            }
            case 2 : {
               resValue = value.toString().split(' ', 3);
               break;
            }
            default : {
               resValue = value.toString().split(',', 3);
               break;
            }
         }
         const date = resValue[0];
         const month = this.convertMonth(resValue[1]);
         const year = resValue[2] ? this.convertYear(null, 0, resValue[2].substr(0, 4)) : this.convertYear(null, 0, '');
         if (date === '31' && (month === '04' || month === '06' || month === '09' || month === '11')) {
            this.validateDate = true;
         } else if (date >= '30' && month === '02') {
            this.validateDate = true;
         } else if (month === '02' && date === '29' && !(Number(year) % 4 === 0 && (Number(year) % 100 !== 0 || Number(year) % 400 === 0))) {
            this.validateDate = true;
         }

         if (this.form.controls[this.fieldName].invalid) {
            const newMonth: string = this.setMonth(resValue[1]);
            const joinWith = (this.field.separateDate === 0) ? '-' : (this.field.separateDate === 1) ? '/' : (this.field.separateDate === 2) ? ' ' : ',';
            if (joinWith && newMonth && resValue.length === 3) {
               this.form.controls[this.fieldName].setValue(resValue[0] + joinWith + newMonth + joinWith + resValue[2]);
            }
         }
      }
      if (this.validateDate) {
         this.form.controls[this.fieldName].setErrors({'invalid': true});
      }
   }

   setMonth(value: any) {
      if (typeof value !== 'string') {
         return value;
      }
      value = value.toLowerCase();
      const monthMap = {
         'jan': 'Jan', 'january': 'January',
         'feb': 'Feb', 'february': 'February',
         'mar': 'Mar', 'march': 'March',
         'apr': 'Apr', 'april': 'April',
         'may': 'May', 'MAY': 'May',
         'jun': 'Jun', 'june': 'June',
         'jul': 'Jul', 'july': 'July',
         'aug': 'Aug', 'august': 'August',
         'sep': 'Sep', 'september': 'September',
         'oct': 'Oct', 'october': 'October',
         'nov': 'Nov', 'november': 'November',
         'dec': 'Dec', 'december': 'December',
      }
      return monthMap[value] || value;
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   ngAfterViewInit(): void {
      if (this.eformService.isNotCompleteAllSign) {
         this.isDisabled = this.eformService.isNotCompleteAllSign;
      }
      if (this.haveSign) {
         this.isDisabled = false;
      }
      this.cdr.detectChanges();
   }
}
